import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnStyledImage from "./image";
import { HiddenOnDesktop, HiddenOnPhone } from "./hidden";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPauseCircle } from "@fortawesome/free-solid-svg-icons";

const HeroImage = styled(UnStyledImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 0;
`;
const VideoIcon = styled(FontAwesomeIcon)`
  font-size: 4em;
  position: absolute;
  inset: 50%;
  z-index: 1;
  opacity: 0.3;
  color: var(--color-white);
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none !important;
  }
`;
const HeroVideo = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 0;
`;

const Media = ({ className, media, loading }) => {
  const video = React.useRef();

  const [isPlaying, setIsPlaying] = React.useState(false);

  const togglePlay = () => {
    if (isPlaying) {
      video.current?.pause();
    } else {
      video.current?.play();
    }
    setIsPlaying(!isPlaying);
  };
  return media?.mimeType?.match(/^video/) ? (
    <>
      {!isPlaying && <VideoIcon icon={faPauseCircle} onClick={togglePlay} />}
      <HeroVideo
        ref={video}
        className={className}
        autoPlay
        loop
        muted
        playsInline
        onClick={togglePlay}
      >
        <source
          src={media.localFile.publicURL}
          type={media.mimeType}
          alt={media.mediaAlt}
        />
      </HeroVideo>
    </>
  ) : (
    <HeroImage className={className} image={media} loading={loading} />
  );
};

Media.propTypes = {
  className: PropTypes.string,
  media: PropTypes.object,
  loading: PropTypes.oneOf(["eager", "lazy"]),
};

const MediaWithArtDirection = ({
  className,
  media,
  mobileMedia,
  loading = "lazy",
}) => {
  if (!mobileMedia) {
    return <Media className={className} media={media} loading={loading} />;
  }

  return (
    <>
      {media && (
        <HiddenOnPhone>
          <Media className={className} media={media} loading={loading} />
        </HiddenOnPhone>
      )}
      <HiddenOnDesktop>
        <Media className={className} media={mobileMedia} loading={loading} />
      </HiddenOnDesktop>
    </>
  );
};

MediaWithArtDirection.propTypes = {
  className: PropTypes.string,
  media: PropTypes.object,
  mobileMedia: PropTypes.object,
  loading: PropTypes.oneOf(["eager", "lazy"]),
};

export default MediaWithArtDirection;
